<template>
  <div class="gongde-guide">
    <div class="back-btn" @click="handleBack">
      <img src="https://fe-img.tengzhihh.com/image/bcef926966c12975fbb7e54c43d4cdeb-60x60.png" alt="" />
    </div>
    <div class="gongde-guide-content">
      <div class="title">功德箱说明：</div>
      1、功德箱，又称“福田箱”，往里放钱是供养三宝、广种福田的一种方式。
      <br />
      <br />
      2、功德箱的意义有三：一是培养福报，二是助修行，三是促进佛法流通。
      <br />
      <br />
      3、提示：充值比例是1:7，举例，1元可获得7福德值。同时，只能支付整数数额。
      <br />
      <br />
      4、补充说明：捐献功德箱的订单不赠送用户在灵机产品下任意消费的第二日功德礼包。
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.gongde-guide {
  padding: 16.5px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f8f8f8;
  .back-btn {
    margin-bottom: 16.5px;

    img {
      user-select: none;
      width: 30px;
      height: 30px;
    }
  }
  .title {
    color: #f87a1b;
    font-size: 14.5px;
    line-height: 21.75px;
    margin-bottom: 16.5px;
  }
  .gongde-guide-content {
    background: #ffffff;
    border-radius: 5px;
    padding: 16.5px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14.5px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 21.75px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
